import { Text } from '@clockout-dev/design-elements';
import { BarChartOutlined } from '@ant-design/icons';
import styles from '../styles/eligibilitySummaryCard.module.scss';

function EiligibilitySummaryCardHeader() {
    return (
        <div className={styles.summaryHeader}>
        <Text as="span" size="s" className={styles.summaryTitle}>
            Eligibility Summary
        </Text>
        <span className={styles.summaryHeaderIcon} aria-hidden="true">
            <BarChartOutlined />
        </span>
    </div>
    );
}
export default EiligibilitySummaryCardHeader;